<template>
    <div class="content ht-100v pd-0">
        <div class="content-body pd-10">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item">
                                <router-link to="#">User</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">All Users</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">View All Users</h4>
                    <p class="tx-color-03 tx-12 mg-b-0">{{auth.userInfo.firstName}} {{auth.userInfo.lastName}}</p>
                    <p class="tx-color-03 tx-12 mg-b-0"><strong>Last login:</strong> {{auth.userInfo.userLastLoginDate | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</p>
                </div>
                <div class="d-none d-md-block">
                    <download-excel
                            :data="users"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadExcel')}}
                    </download-excel>
                    <download-excel
                            type="csv"
                            :data="users"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadCsv')}}
                    </download-excel>
                    <button @click="$refs['new-user-modal'].show()" class="btn btn-sm pd-x-15 btn-secondary btn-uppercase mg-l-5">Add New User</button>
                </div>
            </div>
            <base-top-cards :carditems="cards"/>
            <hr>

            <base-table
                    :items="users"
                    :fields="fields"
                    :show-title="true"
                    :is-busy="auth.authLoading"
                    class="mt-2"
                    filter-mode="balances"
            ></base-table>
        </div>
        <b-modal id="newUsers" ref="new-user-modal" :hide-header="true" :hide-footer="true"
                 :centered="true">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal"
                   aria-label="Close" @click="hideModal">
                    <span aria-hidden="true">&times;</span>
                </a>
                <div>
                    <b-form @submit.prevent="createUser">

                        <b-form-group label="First Name:">
                            <b-form-input
                                    type="text"
                                    id="firstName"
                                    required
                                    v-model="model.firstName"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Last Name:">
                            <b-form-input
                                    type="text"
                                    id="lastName"
                                    required
                                    v-model="model.lastName"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Email:">
                            <b-form-input
                                    type="text"
                                    id="userEmail"
                                    required
                                    v-model="model.userEmail"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Role:">
                            <b-select v-model="model.userRole" required>
                                <b-select-option value="ADMIN">Admin</b-select-option>
                                <b-select-option value="OPERATOR">Operator</b-select-option>
                            </b-select>
                        </b-form-group>
                        <base-button title="Create" :loading="auth.authLoading"/>
                    </b-form>
                </div>
            </div><!-- modal-body -->
        </b-modal>
    </div>
</template>

<script>
    import BaseTopCards from "../../components/card/BaseTopCards";
    import BaseTable from "../../components/table/BaseTable";
    import BaseButton from "../../components/button/BaseButton";
    import { PrinterIcon } from 'vue-feather-icons'
    import {mapState} from 'vuex'

    export default {
        name: 'User',
        data() {
            return {
                fields: [
                    { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'firstName', label: 'First Name', sortable: true, sortDirection: 'desc' },
                    { key: 'lastName', label: 'Last Name', sortable: true, class: 'text-left' },
                    { key: 'userEmail', label: 'Email', sortable: true, class: 'text-left' },
                    { key: 'userRole', label: 'Role', sortable: true, class: 'text-left' },
                    { key: 'userStatus', label: 'Status', sortable: true, class: 'text-left' },
                    // { key: 'userLastLoginDate', label: 'Last Login Date', sortable: true, sortDirection: 'desc' },
                    { key: 'userCreatedAt', label: 'Enrollment Date', sortable: true, class: 'text-left' },
                    { key: 'actions', label: 'Action', sortable: true, class: 'text-center' }
                ],
                model:{
                    firstName:'',
                    lastName:'',
                    userEmail:'',
                    userRole:''
                }
            }
        },
        components: {
            BaseTable,
            BaseTopCards,
            BaseButton,
            PrinterIcon
        },
        computed: {
            cards:{
                get(){
                    return [
                        {
                            id: 0,
                            name: 'Total Users',
                            number: this.auth.users.totalUsers,// == null?'0.00':'GHS '+this.numberWithCommas(this.totalGhs),
                            color: 'bg-primary'
                        },
                        {
                            id: 1,
                            name: 'Total Pending Users',
                            number: this.auth.users.totalPendingUsers,// == null?'0.00':'GBP '+this.numberWithCommas(this.totalGbp),
                            color: 'bg-orange'
                        },
                        {
                            id: 2,
                            name: 'Total Active Users',
                            number: this.auth.users.totalActiveUsers,// == null?'0.00':'USD '+this.numberWithCommas(this.totalUsd),
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Total Admin Users',
                            number: this.auth.users.totalAdminUsers,// == null?'0.00':'EUR '+this.numberWithCommas(this.totalEur),
                            color: 'bg-black-8'
                        }
                    ]
                },
                set(){

                }
            },
            users(){
                return  this.auth.users.data
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            ...mapState([
                'auth'
            ])
        },
        methods: {
            hideModal(){
                this.$refs['new-user-modal'].hide();
            },
            createUser: async function () {
                await this.$store.dispatch("auth/initiateEnrollment", this.model, {root: true}).then();
                this.$refs['new-user-modal'].hide();
                await this.$store.dispatch("auth/updateUsers", {
                    request: 'users'
                }, {root: true}).then();
            },
            numberWithCommas(x) {
                let parts = x.toString().split(".");
                if (parts[1] == null)  parts[1] = '00'
                else if (parts[1].length === 0) parts[1] = parts[1]+'00'
                else if (parts[1].length === 1) parts[1] = parts[1]+'0'
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            },
        },
        created() {
            this.$store.dispatch("auth/updateUsers", {orgID: localStorage.orgID}, {root: false}).then()
        }
    }


</script>

<style scoped>

</style>
